import gql from 'graphql-tag';

export const APPROVE_TENDER_ASSESSMENT = gql`
  mutation ApproveTenderAssessment($input: TenderAssessmentInput!) {
    approveTenderAssessment(input: $input)
  }
`;
